/** School/schoolyear derived from a page URL. */
export type TenantParams = {
  school?: string;
  schoolyear?: string;
};

/** The part of a router that derivation needs: the server's matcher and the browser's router both fit. */
export type RouteMatcher = {
  getMatchedRoutes: (pathname: string) => readonly [unknown, Record<string, string>, unknown];
};

/**
 * Derives the tenant by matching the pathname against the real route tree, so `school`/`schoolyear`
 * come from the same `$school`/`{-$schoolyear}` params the routes declare — the equivalent of
 * portal reading React Router's per-request params. A `**` entry is the fuzzy-match remainder
 * (router-core's own not-found signal), so such params are junk and derive no tenant.
 */
export function tenantFromPathname(matcher: RouteMatcher, pathname: string): TenantParams {
  const [, routeParams, foundRoute] = matcher.getMatchedRoutes(pathname);
  if (!foundRoute || routeParams["**"]) return {};
  return { school: routeParams.school, schoolyear: routeParams.schoolyear };
}
